import styles from './cardGrid.module.css';

export const CardGrid = ({ children }) => {
    return <div className={styles.cardGrid}>{children}</div>;
};
